function debounce(fn, wait) {
  let timeout;
  
  function debounced(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => fn.apply(this, args), wait);
  }
  
  debounced.cancel = () => clearTimeout(timeout);
  return debounced;
}

class MarqueeComponent extends HTMLElement {
  connectedCallback() {
    this.init();
    window.addEventListener('resize', debounce(() => this.init(), 250));
    this.addEventListener('pointerenter', () => this.slowDown());
    this.addEventListener('pointerleave', () => this.speedUp());
  }

  init() {
    const wrapper = this.querySelector('[ref="wrapper"]');
    const content = this.querySelector('[ref="content"]');
    const marqueeItems = this.querySelectorAll('[ref="marqueeItems[]"]');

    if (!wrapper || !content || marqueeItems.length === 0) return;

    // Remove existing clone
    const existingClone = wrapper.querySelector('[aria-hidden="true"]');
    if (existingClone) existingClone.remove();

    // Calculate number of copies
    const marqueeWidth = this.offsetWidth;
    const itemWidth = marqueeItems[0]?.offsetWidth || 100;
    const numberOfCopies = Math.ceil(marqueeWidth / itemWidth) + 1;

    // Add repeated items
    for (let i = 1; i < numberOfCopies; i++) {
      const clone = marqueeItems[0].cloneNode(true);
      content.appendChild(clone);
    }

    // Duplicate content for seamless loop
    const clone = content.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    clone.removeAttribute('ref');
    wrapper.appendChild(clone);

    // Calculate speed
    const speedFactor = parseFloat(this.getAttribute('data-speed-factor')) || 25;
    const speed = Math.sqrt(numberOfCopies) * speedFactor;
    this.style.setProperty('--marquee-speed', `${speed}s`);
  }

  slowDown() {
    const wrapper = this.querySelector('[ref="wrapper"]');
    const animation = wrapper?.getAnimations()[0];
    if (animation) animation.playbackRate = 0.5;
  }

  speedUp() {
    const wrapper = this.querySelector('[ref="wrapper"]');
    const animation = wrapper?.getAnimations()[0];
    if (animation) animation.playbackRate = 1;
  }
}

if (!customElements.get('marquee-component')) {
  customElements.define('marquee-component', MarqueeComponent);
}
